import {Permission} from '@sollapay/enums';
import {useDisclosure} from '@sollapay/ui/hooks';
import {AccountMenu} from '@sollapay/web-core';
import {useTranslation} from 'react-i18next';

import {config} from '@/app';
import {AccountSettingsModal} from '@/features/account-settings';
import {FeatureFlag, useFeatureFlag} from '@/features/feature-flags';
import {FirmSettingsModal, useFirmProfileQuery} from '@/features/firm-settings';
import {useCurrentFirmIdentity, useCurrentUserIdentity} from '@/hooks';

import {useUserAccessQuery, usePermissions} from '../hooks';

import type {FC} from 'react';

export const AuthNavAccountCard: FC = () => {
  const {data, isLoading} = useUserAccessQuery();
  const {userId, displayName, pictureUrl, profile} = useCurrentUserIdentity();
  const {data: firmProfile} = useFirmProfileQuery();
  const firm = useCurrentFirmIdentity();
  const {hasPermission} = usePermissions();
  const {t} = useTranslation('common');
  const role = data?.roleKey ? t(`roles.${data.roleKey}`) : undefined;
  const accountSettingsModal = useDisclosure();
  const firmSettingsModal = useDisclosure();
  const accountSettingsEnabled = useFeatureFlag(FeatureFlag.ACCOUNT_SETTINGS);
  const firmSettingsEnabled = useFeatureFlag(FeatureFlag.FIRM_SETTINGS);

  return (
    <>
      <AccountMenu
        claimsNamespace={config.auth0.claimsNamespace}
        role={role}
        isRoleLoading={isLoading}
        onOpenAccountSettings={accountSettingsEnabled ? accountSettingsModal.open : undefined}
        onOpenFirmSettings={firmSettingsEnabled ? firmSettingsModal.open : undefined}
        canEditFirmSettings={hasPermission(Permission.FIRM_SETTINGS_UPDATE)}
        profile={{name: displayName, picture: pictureUrl}}
        firm={firm.name ? firm : undefined}
      />
      <AccountSettingsModal
        isOpen={accountSettingsModal.isOpen}
        profile={profile}
        avatarSeed={userId}
        onClose={accountSettingsModal.close}
      />
      <FirmSettingsModal
        isOpen={firmSettingsModal.isOpen}
        profile={firmProfile}
        onClose={firmSettingsModal.close}
      />
    </>
  );
};
